import { type SetTargetWorkflowPayload } from './target-workflow.actions';

export const PENDING_TARGET_WORKFLOW_STORAGE_KEY = 'blaze-pending-target-workflow';

export type PendingTargetWorkflow = NonNullable<SetTargetWorkflowPayload['workflow']>;

export function storePendingTargetWorkflow(workflow: PendingTargetWorkflow): void {
  localStorage.setItem(PENDING_TARGET_WORKFLOW_STORAGE_KEY, JSON.stringify(workflow));
}

export function restorePendingTargetWorkflow(): PendingTargetWorkflow | null {
  const workflow = getPendingTargetWorkflow();
  if (!workflow) {
    return null;
  }

  localStorage.removeItem(PENDING_TARGET_WORKFLOW_STORAGE_KEY);
  return workflow;
}

function getPendingTargetWorkflow(): PendingTargetWorkflow | null {
  const data = localStorage.getItem(PENDING_TARGET_WORKFLOW_STORAGE_KEY);
  if (!data) {
    return null;
  }

  try {
    return JSON.parse(data) as PendingTargetWorkflow;
  } catch {
    return null;
  }
}
